"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const types_1 = require("@refinitiv-data/types");
const default_session_1 = require("../../../session/default-session");
const service_directory_1 = require("./service-directory");
function Definition(params) {
    return {
        getStream(session = (0, default_session_1.getDefault)(), api = types_1.DEFAULT_OMM_STREAMING_CONNECTION_NAME) {
            return new service_directory_1.ServiceDirectoryProvider(session, api, params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L3ByaWNpbmcvc2VydmljZS1kaXJlY3RvcnkvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpREFBa0g7QUFDbEgsc0VBQThEO0FBQzlELDJEQUErRDtBQUkvRCxTQUFnQixVQUFVLENBQUMsTUFBd0M7SUFDL0QsT0FBTztRQUNILFNBQVMsQ0FBQyxVQUFtQixJQUFBLDRCQUFVLEdBQUUsRUFBRSxNQUFjLDZDQUFxQztZQUMxRixPQUFPLElBQUksNENBQXdCLENBQUMsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLENBQUMsQ0FBQztRQUM5RCxDQUFDO0tBQ0osQ0FBQztBQUNOLENBQUM7QUFORCxnQ0FNQyJ9